import { PqrFilter } from '../../../../../shared/types/modules/pqr';

export const initialValues: PqrFilter = {
    pqrId: '',
    document: '',
    name: '',
    reconsideration: [],
    plate: '',
    policy: '',
    correspondenceFiling: '',
};
